import { render, staticRenderFns } from "./creditRecord.vue?vue&type=template&id=8a4ec6dc"
import script from "./creditRecord.vue?vue&type=script&lang=js"
export * from "./creditRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports